export const rootValue = 100;
export const targetViewWidth = 414;
export const maxViewWidth = 560;

export function px2rem(px: number) {
    if (typeof px !== 'number') {
        // TODO: runtime error?
        throw new Error('px2rem: px must be a number');
    }

    return `${px / rootValue}rem`;
}

export function getViewRatio(targetWidth: number, screenMax: number): () => number {
    if (typeof targetWidth !== 'number' && typeof screenMax !== 'number') {
        return () => 1;
    }
    const value =
        Math.min(typeof document !== 'undefined' ? document.documentElement.clientWidth : maxViewWidth, maxViewWidth) /
        targetWidth;
    return () => {
        return value;
    };
}

export function transViewValue(value: number): number {
    if (typeof value !== 'number') {
        return 0;
    }
    const viewRatio = getViewRatio(targetViewWidth, maxViewWidth);
    return value * viewRatio();
}
